import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const CardWrapper = styled.div`
  background: ${(props) => (props.cardType === "dark" ? "#673490" : "#fff")};
  color: ${(props) => (props.cardType === "dark" ? "#fff" : "#333")};
  border-radius: 4px;
  padding: 10px 0;
  height: fit-content;
  font-family: Raleway;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ${mediaMaxWidth.tablet`
    margin-bottom: 0px;
  `}
`;

export const Row = styled.div`
  display: flex;
  ${mediaMaxWidth.phone`
    flex-direction: column;
  `}
`;

export const CollapsibleLink = styled.a`
  position: absolute;
  bottom: 0;
  background: ${(props) => (props.cardType === "dark" ? "#673490" : "#fff")};
  background: ${(props) =>
    props.cardType === "dark"
      ? "-moz-linear-gradient(top,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0.02) 1%,rgba(103, 52, 144, 1) 47%)"
      : "-moz-linear-gradient(top,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0.98) 48%,rgba(255, 255, 255, 1) 49%)"};
  background: ${(props) =>
    props.cardType === "dark"
      ? "-webkit-linear-gradient(top,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0.02) 1%,rgba(103, 52, 144, 1) 47%)"
      : "-webkit-linear-gradient(top,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0.98) 48%,rgba(255, 255, 255, 1) 49%)"};
  background: ${(props) =>
    props.cardType === "dark"
      ? "linear-gradient(to bottom,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0.02) 1%,rgba(103, 52, 144, 1) 47%)"
      : "linear-gradient(to bottom,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0.98) 48%,rgba(255, 255, 255, 1) 49%)"};
  filter: ${(props) =>
    props.cardType === "dark"
      ? 'progid:DXImageTransform.Microsoft.gradient( startColorstr="#00ffffff",endColorstr="#673490",GradientType=0)'
      : 'progid:DXImageTransform.Microsoft.gradient( startColorstr="#00ffffff",endColorstr="#ffffff",GradientType=0)'};
  width: 100%;
  padding: 80px 0 5px 0;
  text-align: center;
  cursor: pointer;
  color: #f2008c;
  font-weight: 600;

  &:hover {
    color: #673490;
  }
`;

export const Column = styled.div`
  position: relative;
  padding: ${(props) =>
    props.collapsibleType === true ? "15px 0 50px 0" : "15px 0"};
  flex: 1;
  height: 220px;
  overflow: ${(props) => (props.collapsibleType === true ? "hidden" : null)};
  transition: height 0.3s ease-out;

  &.expanded {
    height: auto;

    ${CollapsibleLink} {
      padding: 40px 0 5px 0;
    }
  }
`;

export const Title = styled.div`
  padding: 0 10px 10px 10px;
  border-bottom: 1px solid #d2d2d2;
  font-weight: 600;
  font-size: 1em;
  display: flex;
  justify-content: space-between;
`;

export const Text = styled.div`
  padding: 15px 10px;
  line-height: 1.4em;
  font-size: ${(props) => (props.font === "large" ? "2.2em" : null)};
  font-weight: 300;

  .public-DraftStyleDefault-block {
    margin: 0;
  }
`;

export const Image = styled.img`
  display: flex;
  max-width: 100%;
  max-height: 100px;
`;

export const Link = styled.a`
  display: block;
  color: #f2008c;
  margin-top: 15px;
  text-decoration: none;
  font-weight: 600;
`;
